<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/product/01/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="f-a-j-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="f-a-j-j-content">
                            <p class="text">基于运营平台、移动平台、物联网平台及大数据平台，支持集团化、连锁型养老机构高效营销、标准运营，为客户提供精准化服务和智慧化照护。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content-child"
                v-for="(src,i) of imgArr"
                :key="i"
            >
                <div class="content-w">
                    <img :src="src" width="100%" alt="" />
                </div>
            </div>
            <div class="w-m-d-y-s page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="w-m-d-y-s-content">
                            <div class="title">
                                <span>我们的</span>
                                <span>优势</span>
                            </div>
<!--                            <div class="w-m-d-y-s-content">-->
                                <div class="w-m-d-y-s-list-box">
                                    <auto-row class="w-m-d-y-s-list" :wrap="true">
                                        <auto-col class="w-m-d-y-s-list-item" min="40%" size="680" max="50%">
                                            <div class="w-m-d-y-s-list-item-label middle">懂养老更专业</div>
                                            <p class="w-m-d-y-s-list-item-text">
                                                公司专注于智慧养老产业，与养老企业、组织进行全面战略合作，精准把脉养老产业走向，为养老服务奠定身后基础。
                                            </p>
                                        </auto-col>
                                        <auto-col class="w-m-d-y-s-list-item" min="40%" size="680" max="50%">
                                            <div class="w-m-d-y-s-list-item-label middle">精研发高品质</div>
                                            <p class="w-m-d-y-s-list-item-text">
                                                公司核心成员均拥有超10年的互联网、物联网、大数据等技术经验。平台支持全定制服务，对接简便、快捷。产品更新迭代快，适用范围广，实用性强。
                                            </p>
                                        </auto-col>
                                        <auto-col class="w-m-d-y-s-list-item" min="40%" size="680" max="50%">
                                            <div class="w-m-d-y-s-list-item-label middle">运营更省心</div>
                                            <p class="w-m-d-y-s-list-item-text">
                                                全面定制智慧养老运营方案，提供平台、运营、服务三位一体方案，真正做到智慧养老一站式服务。
                                            </p>
                                        </auto-col>
                                        <auto-col class="w-m-d-y-s-list-item" min="40%" size="680" max="50%">
                                            <div class="w-m-d-y-s-list-item-label middle">全客户端适配</div>
                                            <p class="w-m-d-y-s-list-item-text">
                                                办公设备结合移动设备，随时随地了解养老数据。管理简化流程、节省人力，实现移动办公。
                                            </p>
                                        </auto-col>
                                    </auto-row>
<!--                                </div>-->

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="q-c-j-s-p-wrap q-c-j-s-p page-content-child" style="background-color:#F9F9F9;">
                <div class="q-c-j-s-p-box content-w">
                    <div class="q-c-j-s-p-content page-content-box">
                        <div class="f-a-j-j-content">
                            <div class="title">
                                <span>全客户端</span>
                                <span>适配</span>
                            </div>
                        </div>
                        <div class="q-c-j-s-p-list-box">
                            <auto-row class="q-c-j-s-p-list" :wrap="true">
                                <auto-col class="q-c-j-s-p-list-item" min="300" size="332" max="570">
                                    <div class="q-c-j-s-p-list-item-label middle">WEB端</div>
                                    <auto-row class="q-c-j-s-p-list-item-text" justify="center">
                                        <auto-col max="100%">
                                            <p>设施设备后台管理</p>
                                            <p>民政监管端</p>
                                            <p>照料中心端</p>
                                            <p>运营中心端</p>
                                            <p>养老院管理</p>
                                            <p>居家服务端</p>
                                            <p>……</p>
                                        </auto-col>
                                    </auto-row>
                                </auto-col>
                                <auto-col class="q-c-j-s-p-list-item" min="300" size="332" max="570">
                                    <div class="q-c-j-s-p-list-item-label middle">大屏端</div>
                                    <auto-row class="q-c-j-s-p-list-item-text" justify="center">
                                        <auto-col max="100%">
                                            <p>数据运营可视化监</p>
                                            <p style="text-align:center;">……</p>
                                        </auto-col>
                                    </auto-row>
                                </auto-col>
                                <auto-col class="q-c-j-s-p-list-item" min="300" size="332" max="570">
                                    <div class="q-c-j-s-p-list-item-label middle">电视机/自助一体机</div>
                                    <auto-row class="q-c-j-s-p-list-item-text" justify="center">
                                        <auto-col max="100%">
                                            <p>院内接待</p>
                                            <p>形象展示</p>
                                            <p>……</p>
                                        </auto-col>
                                    </auto-row>
                                </auto-col>
                                <auto-col class="q-c-j-s-p-list-item" min="300" size="332" max="570">
                                    <div class="q-c-j-s-p-list-item-label middle">手机端/小程序/PAD端</div>
                                    <auto-row class="q-c-j-s-p-list-item-text" justify="center">
                                        <auto-col max="100%">
                                            <p>适用于：社会人士，包括老人及家属、民政人员、机构人员、照料中心人员、上门服务人员、商家、评估人员</p>
                                            <p>……</p>
                                        </auto-col>
                                    </auto-row>
                                </auto-col>
                            </auto-row>
                        </div>

                    </div>
                </div>
            </div>
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    // require('@/assets/image/product/01/pic-1.png'),
                    require('@/assets/image/product/01/pic-2.png'),
                    // require('@/assets/image/product/01/pic-3.png'),
                    // require('@/assets/image/product/01/pic-4.png'),
                ]
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }
    .page-content{
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(2),.page-content-child:nth-child(4){
        background-color:#F9F9F9;
    }
    .page-content-child:nth-child(1),.page-content-child:nth-child(3){
        background-color: #FFFFFF;
    }

    .page-content-child .title span:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }
    .page-content-child .title span:nth-child(2){
        color:#2FA8D0;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
    }


    .f-a-j-j .f-a-j-j-content{
        text-align: center;
        padding:120px 0 145px 0;
    }

    .f-a-j-j .text{
        color:#333333;
        font-size: 24px;
        padding:0 140px 0 140px;
        line-height: 1.6;
        transition: all .3s;
    }

    .f-a-j-j .text:hover{
        transform: translateY(-5px);
    }


    .w-m-d-y-s .w-m-d-y-s-content{
        text-align: center;
        padding:154px 0 180px 0;
    }


    .s-q-y-l-g-l .list-item .cell .text{
        line-height: 1.6;
        padding-top:20px;
        font-size: 18px;
        color:#333333;
    }


    .w-m-d-y-s .w-m-d-y-s-content{
        text-align: center;
        padding:100px 0 150px 0;
    }

    .w-m-d-y-s .list-item .cell .text{
        line-height: 1.6;
        padding-top:15px;
        font-size: 18px;
    }

    .w-m-d-y-s-list-box{
        overflow: hidden;
        margin-top:68px;
    }
    .w-m-d-y-s-list{
        width:calc(100% + 40px) !important;
    }
    .w-m-d-y-s-list-item{
        margin-right:40px;
        margin-bottom:20px;
        margin-top:20px;
        min-height:210px;
        padding:34px 50px 20px;
        background-color:#2FA7CF;
        background-repeat:no-repeat;
        background-size:auto 100%;
        transition: all .3s;
    }

    .w-m-d-y-s-list-item:hover{
        transform: translateY(-5px);
        font-weight: bold;
    }

    .w-m-d-y-s-list-item:nth-of-type(1){
        background-image: url('~@/assets/img/01.png');
        background-position: right bottom;
    }
    .w-m-d-y-s-list-item:nth-of-type(2){
        background-image: url('~@/assets/img/02.png');
        background-position: left bottom;
    }
    .w-m-d-y-s-list-item:nth-of-type(3){
        background-image: url('~@/assets/img/03.png');
        background-position: right top;
    }
    .w-m-d-y-s-list-item:nth-of-type(4){
        background-image: url('~@/assets/img/04.png');
        background-position: left top;
    }
    .w-m-d-y-s-list-item-label{
        color:#fff;
        font-size:24px;
        line-height:36px;
        font-weight:bold;
        text-align: left;
    }
    .w-m-d-y-s-list-item-text{
        margin-top:20px;
        font-size: 20px;
        color: #FFFFFF;
        text-align: left;
    }


    .q-c-j-s-p .q-c-j-s-p-content{
        text-align: center;
        padding:163px 0 165px 0;
    }


    .q-c-j-s-p-list-box{
        overflow: hidden;
        margin-top:117px;
    }
    .q-c-j-s-p-list{
        width:calc(100% + 24px) !important;
    }
    .q-c-j-s-p-list-item{
        margin-right:24px;
        margin-bottom:12px;
        margin-top:12px;
        background-color:#fff;
    }
    .q-c-j-s-p-list-item-label{
        max-height:172px;
        min-height:86px;
        height:13vw;
        color:#fff;
        font-size:24px;
        font-weight:bold;
        text-align:center;
        background-color:#2FA8D0;
        background-repeat:no-repeat;
    }
    .q-c-j-s-p-list-item:nth-of-type(1) .q-c-j-s-p-list-item-label{
        background-image: url('~@/assets/img/cjsp-web.png');
        background-position: right top;
        background-size:74px auto;
    }
    .q-c-j-s-p-list-item:nth-of-type(2) .q-c-j-s-p-list-item-label{
        background-image: url('~@/assets/img/cjsp-dp.png');
        background-position: right -8px;
        background-size:74px auto;
    }
    .q-c-j-s-p-list-item:nth-of-type(3) .q-c-j-s-p-list-item-label{
        background-image: url('~@/assets/img/cjsp-tv.png');
        background-position: right -14px;
        background-size:78px auto;
    }
    .q-c-j-s-p-list-item:nth-of-type(4) .q-c-j-s-p-list-item-label{
        background-image: url('~@/assets/img/cjsp-sj.png');
        background-position: calc(100% + 10px) top;
        background-size:74px auto;
    }
    .q-c-j-s-p-list-item-text{
        padding:16px;
        font-size: 20px;
        color: #333333;
        line-height: 34px;
        min-height:270px;
    }



    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){


    }

    @media screen and (max-width: 1200px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:100px 0 125px 0;
        }

        .f-a-j-j .text{
            color:#333333;
            font-size: 24px;
            padding:0 120px 0 120px;
            line-height: 1.6;
            transition: all .3s;
        }

        .w-m-d-y-s .w-m-d-y-s-content, .q-c-j-s-p .q-c-j-s-p-content{
            text-align: center;
            padding:80px 0 130px 0;
        }
        .w-m-d-y-s-list-box,.q-c-j-s-p-list-box{
            margin-top:60px;
        }
    }

    @media screen and (max-width: 960px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:80px 0 100px 0;
        }

        .f-a-j-j .text{
            color:#333333;
            font-size: 24px;
            padding:0 60px 0 60px;
            line-height: 1.6;
            transition: all .3s;
        }


        .w-m-d-y-s .w-m-d-y-s-content,.q-c-j-s-p .q-c-j-s-p-content{
            text-align: center;
            padding:60px 0 110px 0;
        }
        .w-m-d-y-s-list-box,q-c-j-s-p-list-box{
            margin-top:50px;
        }
    }

    @media screen and (max-width: 760px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:60px 0 110px 0;
        }

        .f-a-j-j .text{
            color:#333333;
            font-size: 24px;
            padding:0 20px 0 20px;
            line-height: 1.6;
            transition: all .3s;
        }


        .w-m-d-y-s .w-m-d-y-s-content, .q-c-j-s-p .q-c-j-s-p-content{
            text-align: center;
            padding:60px 0 80px 0;
        }
        .w-m-d-y-s-list-box,q-c-j-s-p-list-box{
            margin-top:40px;
        }

    }
</style>
